<template>
  <div class="result-page">
    <div class="left-pane" :class="{ 'mobile-pane-hidden': isMobile && mobileView !== 'list' }">
      <GameSearch :sport="sport" @game-selected="handleGameSelected" />
    </div>
    <div class="right-pane" :class="{ 'mobile-pane-hidden': isMobile && mobileView !== 'details' }">
      <GameDetails :selectedGameId="selectedGameId" :sport="sport" />
    </div>
  </div>
</template>


<script>
import GameSearch from './GameSearch.vue';
import GameDetails from './GameDetails.vue';

export default {
  components: {
    GameSearch,
    GameDetails
  },
  props: {
    sport: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      selectedGameId: null,
      isMobile: false,
      mobileView: 'list'
    };
  },
  watch: {
    '$route.params.gameId': {
      immediate: true,
      handler(newGameId) {
        this.selectedGameId = newGameId;
        if (this.isMobile) {
          this.mobileView = newGameId ? 'details' : 'list';
        }
      }
    }
  },
  mounted() {
    this.updateViewportMode();
    window.addEventListener('resize', this.updateViewportMode);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.updateViewportMode);
  },
  methods: {
    updateViewportMode() {
      this.isMobile = window.innerWidth <= 900;
      if (!this.isMobile) {
        this.mobileView = 'details';
        return;
      }
      this.mobileView = this.selectedGameId ? 'details' : 'list';
    },
    handleGameSelected(gameId) {
      this.selectedGameId = gameId;
      if (this.isMobile) {
        this.mobileView = 'details';
      }
      this.$router.push(`/${this.sport}/${gameId}`);
    }
  }
}
</script>

<style scoped>
.result-page {
  display: flex;
  align-items: stretch;
  gap: 0;
  min-height: calc(100vh - 120px);
}

.mobile-switcher {
  display: none;
}

.left-pane {
  width: min(360px, 32%);
  min-width: 300px;
  overflow-y: auto;
  box-sizing: border-box;
  border-right: 1px solid #e9eef3;
  background: #ffffff;
  position: sticky;
  top: 0;
  align-self: flex-start;
  max-height: calc(100vh - 64px);
}

.right-pane {
  min-width: 0;
  display: flex;
  flex-direction: column;
  flex: 1;
  background: #ffffff;
}

@media (max-width: 900px) {
  .result-page {
    flex-direction: column;
    min-height: auto;
  }

  .left-pane {
    width: 100%;
    min-width: 0;
    position: static;
    max-height: none;
    border-right: none;
    border-bottom: 1px solid #e9eef3;
  }

  .right-pane {
    width: 100%;
  }

  .mobile-pane-hidden {
    display: none;
  }
}
</style>

